module.exports = __webpack_public_path__ + "img/room_1.ca415b80.jpg";